import { NavigationData } from "../types/header.types";

export const navigation: NavigationData = {
  categories: [
    {
      id: "brands",
      name: "Brands",
      featured: [
        {
          name: "Serpent - SB4001-SEPIA",
          href: "/SB4001-SEPIA",
          imageSrc: "/features/sb4001-sepia.png",
          imageAlt: "Serpent - SB4001-SEPIA",
        },
        {
          name: "Whitestone - P331 EVL",
          href: "/WAI-P331-EVL",
          imageSrc: "/features/whitestone_evl.jpeg",
          imageAlt: "Whitestone - P331 EVL",
        },
      ],
    },
    {
      id: "equipment",
      name: "Equipment",
      featured: [
        {
          name: "ELI BIG-FrEQ",
          href: "/big-freq",
          imageSrc: "/features/big-freq.jpg",
          imageAlt: "ELI BIG-FrEQ.",
        },
        {
          name: "Useful Arts - Hornet",
          href: "/hornet",
          imageSrc: "/features/hornet_angle_reflection.png",
          imageAlt: "Useful Arts - Hornet",
        },
      ],
    },
  ],
  pages: [
    { name: "Company", href: "/company" },
    { name: "Contact", href: "/contact" },
  ],
}; 